
import NoticShow from '../smallComponent/NoticShow';
import Quick_Actions from '../smallComponent/Quick_Actions';
import Stats_Grid from '../smallComponent/Stats_Grid';

const EmployeeDashboard = ({ user }) => {

  return (
    <div className="space-y-6">


      {/* Header */}


      {/* Stats Grid */}

<Stats_Grid user={user}/>
      {/* Quick Actions */}
<Quick_Actions/>

            {/* Notices Section on Top */}
<NoticShow/>
    </div>
  );
};

export default EmployeeDashboard;
